<script setup>
import { AccountLink } from '@rei/account-flyout';
</script>

<template>
  <div class="item-account-link">
    <AccountLink />
    <AccountLink
      link-text="My Account - Sign in or Register"
      mounting-point-selector="[data-js='mobile-nav-login-link']"
      is-mobile-only
    />
  </div>
</template>

<style>
.item-account-link {
  padding: 8px;
}
</style>
